import { Navigate, useParams } from "react-router-dom";
import { useQuery, useReactiveVar } from "@apollo/client";
import { GET_PACKAGE_INFO } from "../../graphql/operations/campaignOperations/operations";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { PackageType } from "../../graphql/generated";
import {
  Box,
  Divider,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { createContext } from "react";
import { useContext } from "react";
import { DetailsSummary } from "./DetailsSummary";
import { TargetDetailsSummary } from "./TargetDetailsSummary";
import { userDetailsVar } from "../../lib/cache";
import { FormSubSectionHeader } from "../../components/formSubSectionHeader/FormSubSectionHeader";

interface IPackageSummary {
  segment: PackageType;
}

const segmentContext = createContext({} as IPackageSummary);

export const useSegmentInfo = () => {
  return useContext(segmentContext);
};

export const SegmentSummaryPage = () => {
  const currentUser = useReactiveVar(userDetailsVar);
  const { id: segmentId } = useParams();

  if (!segmentId) {
    return <Navigate to={"/404"} />;
  }

  const { data, loading, error } = useQuery(GET_PACKAGE_INFO, {
    variables: {
      id: segmentId,
    },
    fetchPolicy: "cache-and-network",
  });

  if (!currentUser) {
    return <ComponentLoading text={"Loading page..."} />;
  }

  if (
    !(currentUser?.isStaff || currentUser?.agency.partner)
  ) {
    return <Navigate to={"/"} />;
  }

  if (loading && !data) {
    return <ComponentLoading text={"Loading your segment information..."} />;
  }

  if (error) {
    return <Navigate to={"/404"} />;
  }

  const segmentInfo: PackageType = data.packageInfo;

  return (
    <segmentContext.Provider value={{ segment: segmentInfo }}>
      {/* <Flex mb={8} justifyContent={"space-between"}>
        {/* <Box as={"button"} onClick={() => history.back()}>
          <HStack
            spacing={1}
            _hover={{
              stroke: "primary.darker",
              color: "primary.darker",
            }}
            align={"center"}
          >
            <Icon
              as={IoIosArrowRoundBack}
              width={6}
              height={6}
              strokeWidth={10}
            />
            <Text fontSize={"sm"}>
              Back
              {/* {currentUser?.isStaff ? "Back to Campaigns" : "Back to Your Campaigns"}
            </Text>
          </HStack>
        </Box>
      </Flex> */}
      <Box
        p={10}
        bg={"white"}
        borderRadius={"sm"}
        w={"100%"}
        height={"100%"}
        justifyContent={"center"}
      >
        <VStack align={"flex-start"}>
          {/* <Text ml={3} fontWeight={"medium"}> {"Details"}</Text> */}

          <FormSubSectionHeader label={"Details"} margin={"4"} />
          <Divider borderColor={"muted"} mb={1} ml={4} w={"100%"} />
            <HStack alignItems="flex-start" width="100%" height="100%" >
              <Box w={"100%"} p={2}>
                  <DetailsSummary variant="flex" />
                </Box>
              <Box w={"100%"} p={2}>
                  <TargetDetailsSummary />
              </Box>
            </HStack>
        </VStack>
      </Box>
    </segmentContext.Provider>
  );
};
